import React from 'react';
import { Checkbox, Typography } from '@vtblife/uikit';
import Icon from '@vtblife/uikit-icons';

import classname from '@search/classname/src';
import { MortgageProgramCodeType } from '@search/graphql-typings';
import { MORTGAGE_PROGRAMS } from '../../common/constants';

import './style.css';

const cn = classname.bind(null, 'DesktopMortgagePrograms');

export const DesktopMortgagePrograms = ({
    stateProgramCode,
    onChange,
}: {
    stateProgramCode: MortgageProgramCodeType;
    onChange: (value: string | number) => void;
}) => {
    const currentProgram = MORTGAGE_PROGRAMS.find(item => item.mortgageProgramCodes === stateProgramCode);
    const drawMortgageProgramItems = () => {
        return (
            <>
                {MORTGAGE_PROGRAMS.map((item, index) => (
                    <div
                        className={cn('item', { selected: item.mortgageProgramCodes === stateProgramCode })}
                        key={index}
                        onClick={() => {
                            onChange(item.mortgageProgramCodes);
                        }}
                    >
                        <div
                            className={cn('program')}
                        >
                            <div className={cn('programNameWrap')}>
                                <Typography
                                    className={cn('programName')}
                                    variant='secondary-alone'
                                >
                                    {item.name}
                                </Typography>
                                {item.label && (
                                    <div className={cn('labelWrap')}>
                                        <Typography variant='small-alone' className={cn('label')}>
                                            {item.label[0]}
                                        </Typography>
                                    </div>
                                )}
                            </div>
                            <Checkbox
                                color='primary'
                                radio
                                value={item.mortgageProgramCodes === stateProgramCode}
                            />
                        </div>
                        <Typography variant='h3'>{item.mortgagePercent}</Typography>
                    </div>
                ))}
            </>
        );
    };

    return (<div className={cn()}>
        <Typography variant='primary-alone' bold className={cn('title')}>
            Программы
        </Typography>
        <div className={cn('mortgageItems')}>
            {drawMortgageProgramItems()}
        </div>
        {currentProgram?.infoDesk && (<div className={cn('disclaimer')}>
            <span className={cn('information')}>
                <Icon name='information-circle' size='s' color='rgba(116, 109, 147, 0.5)' />
            </span>
            {currentProgram.infoDesk.map((item, index) => (
                <Typography
                    key={index}
                    variant='secondary-alone'
                    color='secondary'
                >
                    {item}
                </Typography>
            ))}
        </div>)}
    </div>);
};
